import request from 'assets/js/http';

export function noteLists() {
  // 提醒配置列表
  return request({
    url: '/config/companyNotify/list',
    method: 'post'
  });
}
export function saveConfig(data) {
  // 提醒配置列表
  return request({
    url: '/config/companyNotify/save',
    method: 'post',
    data
  });
}
